import * as S from "./styled"
import { Lock } from "lucide-react"

import getStore from "../../store"
import { TOrganizer } from "../../utils/@types/data/organizer"
import { getFormattedRegister } from "../../utils/tb/formatters/getFormattedRegister"

type Props = {
  customData?: TOrganizer
  variant?: "full" | "minimal"
}

const Footer = ({ customData, variant = "full" }: Props) => {
  const { event } = getStore()

  const rawDocument = ((customData?.CNPJ ?? event?.CNPJ) ?? "").replace(/\D/g, "")
  const registerLabel = rawDocument.length <= 11 ? "CPF" : "CNPJ"

  const getRegister = () => getFormattedRegister(rawDocument)

  const corporateName = (customData?.corporateName ?? event?.corporateName)

  return (
    <S.Component>
      <S.CopyArea>
        <S.CopyInner>
          <S.SecurityBadge aria-hidden="true">
            <Lock size={14} strokeWidth={2.25} />
          </S.SecurityBadge>
          <S.CopyItem>
            <S.CopyLabel>Ambiente seguro</S.CopyLabel>
            {variant === "minimal" ? (
              <S.CopyText>
                Compra protegida e dados criptografados
              </S.CopyText>
            ) : (
              <S.CopyText>
                Ingressos vendidos sob responsabilidade de{" "}
                <strong>{corporateName}</strong> — {registerLabel} {getRegister()}
              </S.CopyText>
            )}
          </S.CopyItem>
        </S.CopyInner>
      </S.CopyArea>
    </S.Component>
  )
}

export default Footer
